import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import { translations } from "../../../../translate.js";
import CircularProgress from "@material-ui/core/CircularProgress";

let Strings =
    localStorage.getItem("LANG") == 1 ? translations.Ar : translations.En;

class EFAWATEERcomCommissionForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            submitError: "",
            efawatercomAPI: [],
            id: this.props.data[0].id,
            apiType: this.props.data[0].apiType,
            profitPercentege: this.props.data[0].profitPercentege,
            distCommission: this.props.data[0].distCommission,
            posCommission: this.props.data[0].PosCommission,
            formName: this.props.data[0].typeName,
            apiCommission: this.props.data[0].apiCommission,
            loadingSave: 0,
            loading: 0,
        };
    }
    componentDidMount() {
        console.log(this.props.data[0]);
    }

    handleValidSubmit = (event) => {
        this.setState({ loadingSave: 1 });
        event.preventDefault();
        fetch(window.API_PERM_USER, {
            method: "POST",
            body: JSON.stringify({
                type: "add_or_edit_efawatercom",
                lang: localStorage.getItem("LANG"),
                userId: localStorage.getItem("USER_ID"),
                token: localStorage.getItem("USER_TOKEN"),
                id: this.state.id,
                apiType: this.state.apiType,
                DistCommission: this.state.distCommission,
                PosCommission: this.state.posCommission,
                ProfitPercentege: this.state.profitPercentege,
                ApiCommission: this.state.apiCommission,
            }),
            headers: {
                Accept: "application/json",
            },
        })
            .then(function (response) {
                return response.json();
            })
            .then((data) => {
                if (data !== "Nothing found") {
                    if (data["logout"] == 1) {
                        localStorage.setItem("USER_ID", "");
                        localStorage.setItem("USER_TOKEN", "");
                        window.location.href = "/logout";
                    } else if (data["error"] == 1) {
                        this.setState({
                            submitError: data["errorMsg"],
                        });
                    } else {
                        this.setState({ loadingSave: 0 });
                        this.props.handleFormAction();
                    }
                }
            });
    };

    handleInputChange = (event) => {
        const target = event.target;
        const name = target.name;
        const value = target.value;
        this.setState({
            [name]: value,
            submitError: "",
        });
    };

    setUpSelectOptions = (type) => {
        var list = "";
        if (type == "apiType") {
            list = this.state.efawatercomAPI.map((rowData, index) => {
                return (
                    <option value={rowData.id} key={index}>
                        {rowData.name}
                    </option>
                );
            });
        }
        return list;
    };

    render() {
        return (
            <div className="view-modal-style">
                <div className="sidebar-header-view">
                    <Row>
                        <Col lg={10} md={10} sm={10} xs={10}>
                            <div className="p-0 main-color-1  sidebar-header-title">
                                {" "}
                                {Strings["Edit"]} {this.state.formName}
                            </div>
                        </Col>
                        <Col lg={2} md={2} sm={2} xs={2} className="text-right">
                            <HighlightOffIcon
                                onClick={this.props.handleCloseSideBar}
                                className="modal-close-icon"
                            />
                        </Col>
                    </Row>
                </div>

                <div className="sidebar-body-view">
                    {this.state.loading == 0 && (
                        <AvForm
                            onValidSubmit={this.handleValidSubmit}
                            ref={(c) => (this.form = c)}
                        >
                            <AvField
                                name="apiCommission"
                                label={Strings["API Commission"] + " *"}
                                placeholder={Strings["Enter"] + " " + Strings["API Commission"]}
                                value={this.state.apiCommission}
                                required
                                onChange={this.handleInputChange}
                                errorMessage={Strings["This field is required"]}
                            />
                            <AvField
                                name="profitPercentege"
                                label={Strings["Profit Percentage"] + " *"}
                                placeholder={
                                    Strings["Enter"] + " " + Strings["Profit Percentage"]
                                }
                                value={this.state.profitPercentege}
                                required
                                onChange={this.handleInputChange}
                                errorMessage={Strings["This field is required"]}
                            />

                            <AvField
                                name="distCommission"
                                label={Strings["Distributor Commission"] + " *"}
                                placeholder={
                                    Strings["Enter"] + " " + Strings["Distributor Commission"]
                                }
                                value={this.state.distCommission}
                                required
                                onChange={this.handleInputChange}
                                errorMessage={Strings["This field is required"]}
                            />
                            <AvField
                                name="posCommission"
                                label={Strings["POS Commission"] + " *"}
                                placeholder={Strings["Enter"] + " " + Strings["POS Commission"]}
                                value={this.state.posCommission}
                                required
                                onChange={this.handleInputChange}
                                errorMessage={Strings["This field is required"]}
                            />

                            <div className="text-right mt-4">
                                {this.state.loadingSave == 1 ? (
                                    <button
                                        type="button"
                                        className="btn form-save-btn mr-1 ml-1 task-action-btn-loading"
                                    >
                                        <CircularProgress className="SaveCircularProgressColor" />{" "}
                                        {Strings["Save"]}
                                    </button>
                                ) : (
                                    <button type="submit" className="btn form-save-btn mr-1 ml-1">
                                        {" "}
                                        {Strings["Save"]}{" "}
                                    </button>
                                )}

                                <button
                                    type="button"
                                    className="btn form-cancel-btn m-l-10"
                                    onClick={this.props.handleCloseSideBar}
                                >
                                    {Strings["Cancel"]}
                                </button>
                            </div>

                            {this.state.submitError && (
                                <div className="error-text-black">
                                    <i className="flaticon2-exclamation error-icon mr-1" />{" "}
                                    {this.state.submitError}
                                </div>
                            )}
                        </AvForm>
                    )}
                    {this.state.loading == 1 && this.state.efawatercomAPI.length <= 0 && (
                        <Row>
                            <Col md={12} style={{ marginTop: "11%" }} className="text-center">
                                <div className="card-body">
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-1"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-2"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-1"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-2"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-1"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-2"
                                        role="status"
                                    ></div>
                                </div>
                            </Col>
                        </Row>
                    )}
                </div>
            </div>
        );
    }
}

export default EFAWATEERcomCommissionForm;
